<script lang="ts">
	import { ChevronDown, ChevronUp } from 'lucide-svelte';
	import { slide } from 'svelte/transition';

	export let isOpen = false;
	export let title: string;
	export let description: string;

	function toggleAccordion() {
		isOpen = !isOpen;
	}
</script>

<div class="accordion-item mb-4" aria-expanded={isOpen}>
	<button
		class="accordion-title h-20 w-full text-left"
		on:click={toggleAccordion}
		aria-controls="accordion-content">
		<div class="flex justify-between text-xl">
			<h3 class="w-full">
				{title}
			</h3>
			{#if isOpen}
				<ChevronUp class="w-6" />
			{:else}
				<ChevronDown class="w-6" />
			{/if}
		</div>
	</button>
	{#if isOpen}
		<!-- eslint-disable -->
		<div transition:slide class="accordion-content text-lg text-stone-500">{@html description}</div>
	{/if}
	<hr class="my-8 h-px border-0 bg-gray-200 dark:bg-gray-700" />
</div>
